<style scoped>
  .gradual-blue {
    height: 150px;
    background-color: rgb(0, 136, 247); /* 不支持线性的时候显示 */
    background-image: linear-gradient(to bottom, rgb(0, 136, 247), rgb(104, 142, 247), white);
    background-image: -ms-linear-gradient(to bottom, rgb(0, 136, 247), rgb(104, 142, 247), white);
    background-image: -webkit-linear-gradient(to bottom, rgb(0, 136, 247), rgb(104, 142, 247), white);
    background-image: -moz-linear-gradient(to bottom, rgb(0, 136, 247), rgb(104, 142, 247), white);
    padding: 10px;
  }


  .num1 {
    font-size: 40px;
    /*color:#027DB4;*/
    font-weight: 600;
  }

  .num2 {
    color: #027DB4;
  }

  .round-grey {
    background: #F0F0F0;
    border: 1px #F0F0F0 solid;
    border-radius: 25px;
    margin-bottom: 20px;
    height: 40px;
    padding: 7px;
  }

  .round-white {
    background: white;
    margin-top: 15px;
    border-radius: 10px;
    border-bottom: 3px solid rgb(242, 242, 242);
  }

  .round-blue {
    background: #E9F0FC;
    color: #5189F6;
    padding: 10px;
    margin: 50px 10px 0 10px;
    border-radius: 10px;
    text-align: left;
    font-weight: 500;
  }

  .row-white {
    padding: 10px;
    border-bottom: 1px solid #EEEEEE;
    margin: 0 10px 0 10px;
    text-align: left;
  }

  .row-grey245 {
    background: #F5F5F5;
    height: 10px;
  }

  .arrow {
    color: white;
    margin-top: 3px;
    margin-left: -4px;
    font-size: 10px;
    transform: rotate(90deg);
    -ms-transform: rotate(90deg); /* IE 9 */
    -moz-transform: rotate(90deg); /* Firefox */
    -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
    -o-transform: rotate(90deg); /* Opera */
  }
</style>
<template>
  <div>
    <van-row class="gradual-blue">
      <van-row style="margin-top: 10px">
      <van-col style="color:rgb(188,211,250)" span="6">数据概览</van-col>
      <van-col span="1" style="margin-top: 4px;margin-left:-9px; color:rgb(188,211,250)">
        <van-icon name="question-o"/>
      </van-col>
      <van-col style="color: white" span="6" offset="10" @click="show=true">{{date}}</van-col>
      <van-col span="1" @click="show=true">
        <van-icon name="play" class="arrow"/>
      </van-col>
      <van-calendar v-model="show" :default-date="vantDate.defaultDate" :min-date="vantDate.minDate" color="#409EFF"
                    @confirm="onConfirm"/>
      </van-row>

      <van-row class="round-white">
        <van-col style="margin-top: 20px" span="24">
          <span>已执行/已预约</span>
        </van-col>
        <van-col span="24">
          <span class="num1">{{sumResults.totalExecutedNumbers}}/{{sumResults.totalNumbers}}</span>
        </van-col>
        <van-col span="8" offset="8" class="round-grey">
          执行率:
          <span class="num2">{{sumResults.totalRate}}</span>
        </van-col>

      </van-row>
    </van-row>
    <van-row class="round-blue">
      <van-col span="10" style="text-align: left">
        医技科室
      </van-col>
      <van-col span="4">
        上午
      </van-col>
      <van-col span="4">
        下午
      </van-col>
      <van-col span="6">
        全天执行率
      </van-col>
    </van-row>

    <template v-for="(item,index) in DetectionDepList">
      <van-row class="row-white" @click="getDepartmentList(item)">
        <van-col span="10" style="text-align: left">
          {{item.detectionDepName}}
        </van-col>
        <van-col span="4">
          {{item.morningExecutedNumbers}}/{{item.morningAppointmentNumbers}}
        </van-col>
        <van-col span="4">
          {{item.afternoonExecutedNumbers}}/{{item.afternoonAppointmentNumbers}}
        </van-col>
        <van-col span="5" style="text-align: center">
          {{item.executedRate}}
        </van-col>
        <van-col span="1" style="text-align: center">
          <van-icon name="arrow" style="padding-top: 2px"/>
        </van-col>
      </van-row>
    </template>

    <van-row class="row-grey245">
      <van-col span="24"></van-col>
    </van-row>

    <van-row style="padding: 10px;margin: 0 10px 0 10px" @click="patientSearch">
      <van-col span="12" style="text-align: left">预约患者搜索</van-col>
      <van-col span="12" style="text-align: right">
        <van-icon name="arrow"/>
      </van-col>
    </van-row>

    <van-row class="row-grey245">
      <van-col span="24"></van-col>
    </van-row>

  </div>
</template>

<script>
  import api from "@/axios/api";
  import { mapGetters, mapActions } from "vuex";
  export default {
    name: "director-info",
    computed: {
        ...mapGetters(["token"])
    },
    watch: {
        token: {
            immediate: true,
            handler: function(val) {
                if (val) {
                    this.getDirectorInfo();
                }
            }
        }
    },
    data() {
      return {
        //字符串类型日期
        date: this.$route.query.bookTime,
        //Calendar日历控件
        vantDate: {
          //默认时间 van日历控件只支持date类型参数
          defaultDate: new Date(Date.parse(this.$route.query.bookTime.replace(/-/g, "/"))),
          //可选择最小时间
          minDate: new Date(Date.parse('1970-01-01'.replace(/-/g, "/")))
        },
        //日期控件默认隐藏
        show: false,
        DetectionDepList: [],
        //全院 总人数/已执行 预约率
        sumResults: {
          totalNumbers: '',
          totalExecutedNumbers: '',
          totalRate: ''
        }
      }
    },
    created: function () {
      
    },
    methods: {
      //获取科室别页面信息
      getDirectorInfo() {
        //获取数据前先清空list,避免数据加载错误后数据有误
        this.sumResults = [];
        this.DetectionDepList = [];
        api.getDirectorInfo(this.date).then(res => {
          this.sumResults.totalNumbers = res.appointmentNumbers;
          this.sumResults.totalExecutedNumbers = res.todayExecutedCount;
          this.sumResults.totalRate = res.executed;
          this.DetectionDepList = res.lists;
        });
      },
      formatDate(date) {
        return date.toLocaleDateString();
      },
      //弹出日期控件
      onConfirm(date) {
        this.show = false;
        this.date = this.formatDate(date);
        this.getDirectorInfo();
      },
      //跳转到科室别列表页
      getDepartmentList(item) {
        this.$router.push({
          path: '/departmentInfo',
          query: {
            bookTime: this.date,
            detectionDepId: item.detectionDepId,
            detectionDepName: item.detectionDepName,
            precise: item.precise
          }
        })
      },
      //跳转到患者搜索页 全院级别  入参bookTime
      patientSearch() {
        this.$router.push({
          path: '/directorDetail',
          query: {
            bookTime: this.date,
            detectionDepId: null,
            precise: null
          }
        })
      }
    }

  }
</script>




// WEBPACK FOOTER //
// src/hospital-admin/pages/director-info.vue